import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'
// import journal from '/BetsyEngineeringJournal.pdf'
import pic01 from '../assets/images/pic01.jpg'
import datacenter from '../assets/images/datacenter.jpg'
import gamescreenshot from '../assets/images/gamescreenshot.png'
import nature from "../assets/images/nature.jpg"
// import pic04 from '../assets/images/pic04.jpg'
// import pic05 from '../assets/images/pic05.jpg'
// import pic06 from '../assets/images/pic06.jpg'

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Abhishek Mallepalli"
                    meta={[
                        { name: 'Abhishek Mallepalli\'s portfolio', content: 'Enjoy' },
                        { name: 'keywords', content: 'Portfolio' },
                    ]}
                >
                     <title>Abhishek Mallepalli</title>
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article style={{backgroundImage: `url(${pic01})`}}>
                            <header className="major">
                                <h3>Earth Landing Project</h3>
                                <p>Sales Website Made With React.js and Node.js</p>
                            </header>
                            <a href="https://www.earthlandingproject.com" className="link primary"></a>
                        </article>
                        <article style={{backgroundImage: `url(${datacenter})`}}>
                            <header className="major">
                                <h3>Deep Dive</h3>
                                <p>Cassandra and PostgreSQL Benchmark Journal</p>
                            </header>
                            <a href='/BetsyEngineeringJournal.pdf' className="link primary"></a>
                        </article>
                        <article style={{backgroundImage: `url(${gamescreenshot})`}}>
                            <header className="major">
                                <h3>JRPG Tech Demo</h3>
                                <p>Tech Demo Made With Defold</p>
                            </header>
                            <Link to="/game/game.html" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${nature})`}}>
                            <header className="major">
                                <h3>Tech Recruiter Portfolio Site</h3>
                                <p>Made With Gatsby</p>
                            </header>
                            <Link to="http://www.punditproservices.com" className="link primary"></Link>
                        </article>
                        {/* <article style={{backgroundImage: `url(${pic05})`}}>
                            <header className="major">
                                <h3>Consequat</h3>
                                <p>Ipsum dolor sit amet</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic06})`}}>
                            <header className="major">
                                <h3>Etiam</h3>
                                <p>Feugiat amet tempus</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article> */}
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2>Welcome to my portfolio</h2>
                            </header>
                            <p> I am a Los Angeles based software engineer that specializes in Javascript.
                                While I am most proficient with MERN stack, I have experience with many web technologies. For more information regarding my prior work, my resume is linked in the header. My interest is creating performant and scalable systems that meet and exceed specifications. I also have deployment experience with several AWS resources including S3, EC2, RDS, and Route 53. I have CI/CD experience. I studied computer science at CSUN and I'm a graduate of Hack Reactor. Feel free to reach out to me with opportunities or just to say 'hi.' You can reach me at <a href="mailto:mallepalliabhishek@gmail.com">mallepalliabhishek@gmail.com</a>
                                </p>
                            {/* <ul className="actions">
                                <li><Link to="/landing" className="button next">Get Started</Link></li>
                            </ul> */}
                        </div>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex